import {
  AppBar as RaAppBar,
  AppBarProps,
  LoadingIndicator,
  TitlePortal,
  UserMenu,
} from 'react-admin';
import { Box, Toolbar, Typography } from '@mui/material';
import React from 'react';
import ThemePreferenceToggle from './ThemePreferenceToggle';

const AppHeader: React.FC<AppBarProps> = ({ userMenu, ...rest }) => {
  const resolvedUserMenu = userMenu === false ? null : React.isValidElement(userMenu) ? userMenu : <UserMenu />;

  return (
    <RaAppBar {...rest} toolbar={false} userMenu={false}>
      <Toolbar
        variant='dense'
        disableGutters
        sx={{
          minHeight: 60,
          px: 0,
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          flexGrow: 1,
        }}
      >
        {/* Sidebar brand area */}
        <Box
          sx={{
            width: 240,
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            px: 2.5,
            gap: 1.5,
            borderRight: '1px solid rgba(255,255,255,0.08)',
            height: 60,
          }}
        >
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: '8px',
              background: 'linear-gradient(135deg, #818CF8 0%, #22D3EE 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              boxShadow: '0 2px 8px rgba(129,140,248,0.4)',
            }}
          >
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#fff', lineHeight: 1 }}>ob</Typography>
          </Box>
          <Box>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#F1F5F9', lineHeight: 1.2, letterSpacing: '-0.01em' }}>
              openBalena
            </Typography>
            <Typography sx={{ fontSize: 10, color: 'rgba(241,245,249,0.45)', lineHeight: 1.2, letterSpacing: '0.02em', textTransform: 'uppercase' }}>
              Admin
            </Typography>
          </Box>
        </Box>

        {/* Page title */}
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', px: 3 }}>
          <TitlePortal />
        </Box>

        {/* Right actions */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            pr: 2,
            flexShrink: 0,
          }}
        >
          <LoadingIndicator sx={{ color: 'rgba(241,245,249,0.6)', mr: 0.5 }} />
          <ThemePreferenceToggle />
          {resolvedUserMenu}
        </Box>
      </Toolbar>
    </RaAppBar>
  );
};

export default AppHeader;
